import React, { useEffect } from "react";
import { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import trash from "../../../../images/icons/delete.svg";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import StaticService from "../../../../services/StaticService";
import BaseService from "../../../../services/BaseService";

const OnBoarding = () => {
	const initial = {
		question_en: "",
		question_ar: "",
		answer_en: "",
		answer_ar: "",
	};
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [allData, setAllData] = useState([]);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const staticService = new StaticService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);

	useEffect(() => {
		setLoading(true);
		staticService
			.getList("onboarding")
			.then((res) => {
				if (res?.status) {
					let response = res?.data?.data?.data;
					if (!!response?.length) {
						setAllData(response);
					} else {
						setAllData([initial]);
					}
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, [shouldUpdate]);

	const submit = (info) => {
		let data = {
			image: info?.image,
			description_en: info?.description_en,
			description_ar: info?.description_ar,
		};

		if (!!info?.id) {
			staticService
				.update("onboarding", info?.id, data)
				?.then((res) => {
					if (res?.status) {
						toast.success("Updated Successfully");
						setShouldUpdate((prev) => !prev);
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			staticService
				.create("onboarding", data)
				?.then((res) => {
					if (res?.status) {
						toast.success("Added Successfully");
						setShouldUpdate((prev) => !prev);
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	const fileHandler = (e, index) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		if (!filesData?.length) {
			return;
		}
		new BaseService().postUpload(filesData[0]).then((res) => {
			if (res?.data?.status) {
				setAllData((prev) =>
					prev.map((response, ind) =>
						ind === index ? { ...response, image: res?.data?.url } : response
					)
				);
			}
		});
	};

	const deleteFaq = (id) => {
		setLoading(true);
		staticService
			.remove("onboarding", id)
			.then((res) => {
				if (res?.status) {
					toast.success("Deleted Successfully");
					setShouldUpdate((prev) => !prev);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	return (
		<div className="department">
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].onboarding}
						</span>
					</div>
				</div>
			</div>

			<div>
				{loading && (
					<div style={{ height: "400px" }}>
						<Loader />
					</div>
				)}
				{allData?.map((data, index) => {
					return (
						<AvForm className="form-horizontal mb-3">
							<Row key={index}>
								<Col
									md={12}
									className="mb-2 d-flex justify-content-between align-items-center">
									<p
										className="mb-0"
										style={{ fontSize: "18px", color: "#000" }}>
										{Translate[lang].onboarding} {index + 1}
									</p>
									<img
										src={trash}
										alt="trash"
										className="cursor-pointer"
										onClick={() => {
											if (!!data?.id) {
												if (isExist("delete_cms")) deleteFaq(data?.id);
											} else if (index > 0) {
												setAllData((prev) => [
													...prev?.filter((_, ind) => index !== ind),
												]);
											} else {
												setAllData([initial]);
											}
										}}
									/>
								</Col>
								{/* Image */}
								<Col md={6} className="mb-3">
									<label className="text-label mb-0">
										{Translate[lang].image}
									</label>
									<div className="upload">
										<input
											type="file"
											name="image"
											id={`image${index}`}
											onChange={(e) => fileHandler(e, index)}
										/>
										<p>{Translate[lang].upload_image}</p>
										{!data?.image ? (
											<svg
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/1000/svg">
												<path
													d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
													stroke="#0F50A6"
													strokeWidth="1.5"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
												<path
													d="M12 15V3.62"
													stroke="#0F50A6"
													strokeWidth="1.5"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
												<path
													d="M15.35 5.85L12 2.5L8.65002 5.85"
													stroke="#0F50A6"
													strokeWidth="1.5"
													strokeLinecap="round"
													strokeLinejoin="round"
												/>
											</svg>
										) : (
											<svg
												width="24"
												height="24"
												viewBox="0 0 16 16"
												fill="none"
												xmlns="http://www.w3.org/1000/svg">
												<path
													d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
													fill="#21AA37"
												/>
											</svg>
										)}
									</div>
									{!!data?.image && (
										<img
											src={data?.image}
											alt="category"
											width={400}
											className="mt-3 border-radius-10"
										/>
									)}
								</Col>
								<Col md={12}>
									<label className="text-label">
										{Translate[lang]?.description} ({Translate[lang]?.english})
									</label>
									<AvField
										type="textarea"
										placeholder={Translate[lang]?.english}
										bsSize="lg"
										style={{
											height: "100px",
										}}
										name={`description_en${index}`}
										validate={{
											required: {
												value: true,
												errorMessage: Translate[lang].field_required,
											},
										}}
										value={data.description_en}
										onChange={(e) =>
											setAllData((prev) =>
												prev.map((res, ind) =>
													ind === index
														? { ...res, description_en: e.target.value }
														: res
												)
											)
										}
									/>
								</Col>
								<Col md={12}>
									<label className="text-label">
										{Translate[lang]?.description} ({Translate[lang]?.arabic})
									</label>
									<AvField
										type="textarea"
										placeholder={Translate[lang]?.arabic}
										bsSize="lg"
										style={{
											height: "100px",
										}}
										name={`description_ar${index}`}
										validate={{
											required: {
												value: true,
												errorMessage: Translate[lang].field_required,
											},
										}}
										value={data.description_ar}
										onChange={(e) =>
											setAllData((prev) =>
												prev.map((res, ind) =>
													ind === index
														? { ...res, description_ar: e.target.value }
														: res
												)
											)
										}
									/>
								</Col>
							</Row>
							{isExist("add_cms") && (
								<Button
									variant="primary"
									onClick={() => submit(data)}
									type="submit"
									disabled={loading}>
									{Translate[lang]?.save}
								</Button>
							)}
							<hr />
						</AvForm>
					);
				})}
				{isExist("add_cms") && (
					<Button
						variant="outline-primary"
						type="button"
						onClick={() => setAllData((prev) => [...prev, initial])}
						className="mb-3 d-block mt-4">
						{Translate[lang]?.add} {Translate[lang]?.onboarding}
					</Button>
				)}
			</div>
		</div>
	);
};
export default OnBoarding;
